import React from "react";

const Trader_Dashboard = () => {
  return <div>Trader_Dashboard</div>;
};

export default Trader_Dashboard;
